import type { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr',
      '-ms-grid-columns': '1fr 1fr',
      '-ms-grid-rows': '1fr',
      alignItems: 'center',
      height: 400,
      marginBottom: '0.7143rem',

      '@media(max-width: 992px)': {
        gridTemplateColumns: '35% 65%',
        '-ms-grid-columns': '35% 65%',
        height: 300
      },

      '@media(max-width:768px)': {
        gridTemplateColumns: '1fr',
        '-ms-grid-columns': '1fr'
      }
    },

    offerTitle: {
      fontSize: 24,
      color: 'white'
    },

    offerDescription: {
      fontSize: 18,
      color: 'white',
      marginTop: '15px',
      marginBottom: '15px'
    },

    offerContent: {
      color: '#FFFFFF',
      gridRow: 1,
      gridColumn: 1,
      '-ms-grid-row-align': 'center',
      position: 'relative'
    },

    image: {
      height: '100%',
      gridRow: 1,
      gridColumn: 2,
      '-ms-grid-row-align': 'center',

      '@media (max-width:768px)': {
        gridRow: 1,
        gridColumn: 1
      }
    }
  });
};
export default styles;
